module.exports = __webpack_public_path__ + "static/media/learn-play-icon.e8fd2ba3.svg";